import { RouteObject } from "react-router-dom-7"
import { Page404 } from "~/shared/ui"

export const routes = [
	{
		lazy: () => import("./layout"), children: [
			{ index: true, element: <Page404/>},
			{ path: ':appName', lazy: () => import("./AppFramePage") },
			{ path: ':appName/*', lazy: () => import("./AppFramePage") }
		],
	}
] satisfies RouteObject[]
